import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { provideExamdojoDateAdapter } from '@examdojo/core/date-time';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { DirtyInvalidErrorStateMatcher } from '@examdojo/angular/forms';
import { ButtonComponent } from '@examdojo/core/button';
import { DateTimeFormat, FormatDatePipe } from '@examdojo/core/date-time';
import { DatepickerToggleDirective } from '@examdojo/core/dialog';
import { IconComponent } from '@examdojo/core/icon';
import { ComponentSize } from '@examdojo/core/model';

@Component({
  selector: 'dojo-date-filter-button',
  imports: [
    ButtonComponent,
    IconComponent,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    DatepickerToggleDirective,
    FormatDatePipe,
  ],
  providers: [provideExamdojoDateAdapter()],
  templateUrl: './date-filter-button.component.html',
  styleUrl: './date-filter-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateFilterButtonComponent {
  readonly control = input.required<FormControl<Date | null>>();
  readonly placeholder = input.required<string>();
  readonly dateFormat = input<DateTimeFormat>(DateTimeFormat.ShortDate);
  readonly size = input<ComponentSize>('s');
  readonly errorStateMatcher = input<ErrorStateMatcher>(new DirtyInvalidErrorStateMatcher());
  readonly min = input<Date | null>(null);
  readonly max = input<Date | null>(null);
}
